import { GenericType } from "@/types";
import { create } from "zustand";

interface ProcessState {
  open: boolean;
  closeAlert: () => void;
  type: "success" | "error" | undefined;
  title?: string | undefined;
  message?: string | undefined;
  alertPopup: (prop: GenericType) => void;
}

export const useAlertPopup = create<ProcessState>((set) => ({
  open: false,
  type: undefined,
  title: undefined,
  message: undefined,
  closeAlert: () =>
    set(() => ({
      open: false,
      type: undefined,
      title: undefined,
      message: undefined,
    })),
  alertPopup: (prop) =>
    set(() => ({
      open: true,
      type: prop.type,
      title: prop.title,
      message: prop.message,
    })),
}));
